/**
 * This module exports Scalyr-defined pure functions to use for dashboard
 */
import { FilterConfigType } from 'components/dashboards/types';

/**
 *
 * @param dashboardFilterConfigList
 * @param name
 * @param filterIndex
 * @returns true or false whether the name for dashboard filter is unique or not based on its index
 */
export const isNameUnique = (
  dashboardFilterConfigList: FilterConfigType[],
  name: string,
  filterIndex?: number,
): boolean =>
  // if the index is the same as the filter we are editing, we return true but for every other index, we compare the names and
  // return true only if the new name is unique
  dashboardFilterConfigList.every((filterConfig, index) => index === filterIndex || name !== filterConfig.name);
